'use strict';

const _ = require('lodash');

const NavStore = function (Flux, NavActions, MapActions, TopControlsActions, APP_DISPATCHER_ID) {

  const Events = {
    Changed: true,
    ShowPopup: true,
    IsEditing: true,
    FinishedEditing: true
  };

  const NavStore = Flux.Store.create({
    name: 'NavStore',
    events: Events
  });

  const store = NavStore;

  NavStore.$state = {
    drawerOpen: false,
    drawerPage: '',
    drawerView: '',
    toView: ''
  };

  let initialized = false;

  NavStore.init = () => {

    if (!initialized) {
      const d = Flux.Dispatcher.get(APP_DISPATCHER_ID);

      d.register(NavActions.ChangeDrawerPage, store.onChangeDrawerPage.bind(store));
      d.register(NavActions.ChangeDrawerPageView, store.onChangeDrawerPageView.bind(store));
      d.register(NavActions.CloseDrawer, store.onCloseDrawer.bind(store));
      d.register(NavActions.OpenDrawer, store.onOpenDrawer.bind(store));
      d.register(NavActions.ChangeDrawerWhileDisabled, store.onChangeDrawerWhileDisabled.bind(store));
      d.register(NavActions.ContinueWithNavigation, store.onContinueWithNavigation.bind(store));

      // Measurements
      d.register(MapActions.NewMeasurementStart, store.handleEditMeasurement.bind(store));
      d.register(MapActions.MeasurementEditEnd, store.handleMeasurementEditEnd.bind(store));
      d.register(MapActions.EditMeasurementStart, store.handleEditMeasurement.bind(store));

      // Annotations
      d.register(MapActions.NewAnnotationStart, store.handleEditAnnotation.bind(store));
      d.register(MapActions.EditAnnotationStart, store.handleEditAnnotation.bind(store));
      d.register(MapActions.AnnotationEditEnd, store.handleAnnotationEditEnd.bind(store));

      // Overlays
      d.register(MapActions.EditOverlayStart, store.handleEditOverlayStart.bind(store));
      d.register(MapActions.EditOverlayEnd, store.handleEditOverlayEnd.bind(store));

      d.register(TopControlsActions.ContinueWithNavigation, store.onContinueWithNavigation.bind(store));
      initialized = true;
    }
  };

  //////////////////////////////////////////////////////////////////////////////
  // Event Handlers
  //////////////////////////////////////////////////////////////////////////////

  NavStore.handleEditMeasurement = () => {

    NavStore.emit(NavStore.Events.IsEditing);
    store.$set('drawerOpen', true);
    store.$set('drawerPage', 'measurements');
    store.$set('drawerView', 'measurements-edit');
  };

  NavStore.handleMeasurementEditEnd = () => {

    NavStore.emit(NavStore.Events.FinishedEditing);
    store.$set('drawerOpen', true);
    store.$set('drawerPage', 'measurements');
    store.$set('drawerView', 'measurements-list');
  };

  NavStore.handleEditAnnotation = () => {

    NavStore.emit(NavStore.Events.IsEditing);
    store.$set('drawerOpen', true);
    store.$set('drawerPage', 'annotations');
    store.$set('drawerView', 'annotations-edit');
  };

  NavStore.handleAnnotationEditEnd = () => {

    NavStore.emit(NavStore.Events.FinishedEditing);
    store.$set('drawerOpen', true);
    store.$set('drawerPage', 'annotations');
    store.$set('drawerView', 'annotations-list');
  };

  NavStore.handleEditOverlayStart = () => {

    NavStore.emit(NavStore.Events.IsEditing);
    store.$set('drawerOpen', true);
    store.$set('drawerPage', 'overlays');
    store.$set('drawerView', 'overlays-edit');
  };

  NavStore.handleEditOverlayEnd = () => {

    NavStore.emit(NavStore.Events.FinishedEditing);
    store.$set('drawerOpen', true);
    store.$set('drawerPage', 'overlays');
    store.$set('drawerView', 'overlays-list');
  };

  NavStore.onChangeDrawerPage = (action) => {

    store.$set('drawerPage', action.page);
    if (typeof action.view !== undefined) {
      store.$set('drawerView', action.view);
    }
  };

  NavStore.onChangeDrawerPageView = (action) => {

    store.$set('drawerView', action.view);
  };

  NavStore.onChangeDrawerWhileDisabled = (action) => {

    NavStore.emit(NavStore.Events.ShowPopup);

    store.$set('toView', action.to);
  };

  NavStore.onContinueWithNavigation = () => {

    const fromView = store.$state.drawerView;
    const toView = store.$state.toView;

    if (fromView === 'overlays-edit') {
      NavStore.handleEditOverlayEnd();
    }
    else if (fromView === 'annotations-edit') {
      NavStore.handleAnnotationEditEnd();
    }

    if (toView) {
      let drawerPage;

      switch (toView) {
      case 'overlays-list':
        drawerPage = 'overlays';
        break;
      case 'annotations-list':
        drawerPage = 'annotations';
        break;
      }

      NavStore.onChangeDrawerPage({page: drawerPage, view: toView});
    }
    else {
      store.$set('drawerOpen', false);
    }

    store.$state.toView = '';
  };

  /*
   * Close the drawer and reset state
   */
  NavStore.onCloseDrawer = () => {

    store.$set('drawerOpen', false);
  };

  /*
   * Open the drawer, optionally setting a page and view if passed in the
   * event params
   */
  NavStore.onOpenDrawer = (action) => {

    store.$set('drawerOpen', true);

    if (typeof action.view !== undefined) {
      store.$set('drawerView', action.view);
    }

    if (typeof action.view !== undefined) {
      store.$set('drawerPage', action.page);
    }
  };


  //////////////////////////////////////////////////////////////////////////////
  // Watchers
  //////////////////////////////////////////////////////////////////////////////

  const _dispatchNotify = _.debounce(() => {

    NavStore.emit(NavStore.Events.Changed);
  }, 10);
  NavStore.watch('drawerOpen', _dispatchNotify);
  NavStore.watch('drawerPage', _dispatchNotify);
  NavStore.watch('drawerView', _dispatchNotify);

  const SiteStore = Flux.Store.get('SiteStore');
  SiteStore.on(SiteStore.Events.Changed, () => {

    NavStore.$set('drawerOpen', false);
    NavStore.$set('drawerView', '');
    NavStore.$set('drawerPage', '');
  });

  return NavStore;
};

NavStore.$inject = ['sbFlux', 'NavActions', 'MapActions', 'TopControlsActions', 'APP_DISPATCHER_ID'];
module.exports = NavStore;


// WEBPACK FOOTER //
// ./src/app/dash/nav/NavStore.js